
import {usePreviewContext} from "../../context/PreviewContext";
import {Typography} from "@mui/material";
import {metaDataProperty} from "../preview/previewMetaData";
import React from "react";

export interface HeadlineProps {
    title?: string | null,
    variant?: 'h3' | 'h4' | 'h6', // Kann bei Bedarf erweitert werden
    propertyName?: string,
    textAlign: 'left' | 'center' | 'right',
    sx?: any
}

function CCOHeadlineAsText(props: HeadlineProps) {
    const isPreview = usePreviewContext().isPreview;

    return props.title && props.title.length > 0 ? (
        <Typography
            variant={props.variant || 'h6'}
            component="p"
            textAlign={props.textAlign}
            sx={props.sx}
            {...metaDataProperty(isPreview, props.propertyName)}
        >
            {props.title}
        </Typography>
    ) : null;
}


export default CCOHeadlineAsText